import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { Offer } from '../../../../../domain/offer.domain';
import { ScheduleFlag } from '../../../../../domain/schedule.model';
import { EntityRole, SystemUser } from '../../../../../domain/user.model';
import { OfferState } from '../../../store/offer.state';
import { ScheduleState } from '../../../store/schedule.state';
import { UserState } from '../../../store/user.state';

@Component({
    selector: 'app-calculation-card',
    templateUrl: './calculation-card.component.html',
    styleUrls: ['./calculation-card.component.scss']
})
export class CalculationCardComponent implements OnInit {

    @Select(OfferState.getOffer) offer$: Observable<Offer>;

    subscriptions: Subscription[] = [];
    user: SystemUser;
    flag: ScheduleFlag;

    get readonly() {
        return this.flag.active === false
            || [EntityRole.WORKER, EntityRole.AGENT, EntityRole.DIRECT_SALES].indexOf(this.user.entityRole) === -1;
    }

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(UserState.getUser).subscribe(user => this.user = user),
            this.store.select(ScheduleState.getFlag).subscribe(flag => this.flag = flag),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }


}
